import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_report_page1 = _resolveComponent("report-page1")!
  const _component_report_page2 = _resolveComponent("report-page2")!
  const _component_report_page3 = _resolveComponent("report-page3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_report_page1, {
      class: "report-page",
      "project-data": _ctx.projectData,
      "include-sections": _ctx.includeSections,
      "payment-type": _ctx.paymentType
    }, null, 8, ["project-data", "include-sections", "payment-type"]),
    (_ctx.shouldShowPage2)
      ? (_openBlock(), _createBlock(_component_report_page2, {
          key: 0,
          class: "report-page",
          "project-data": _ctx.projectData,
          "include-sections": _ctx.includeSections,
          "consumption-data": _ctx.consumptionData,
          "selected-panels": _ctx.selectedPanels,
          "selected-inverters": _ctx.selectedInverters,
          "selected-batteries": _ctx.selectedBatteries,
          selectedEVChargers: _ctx.selectedEVChargers,
          "selected-meters": _ctx.selectedMeters,
          "payment-type": _ctx.paymentType,
          "get-panel-device-count": _ctx.getPanelDeviceCount,
          "get-inverter-device-count": _ctx.getInverterDeviceCount,
          "get-battery-device-count": _ctx.getBatteryDeviceCount,
          getEVChargerDeviceCount: _ctx.getEVChargerDeviceCount,
          "get-meter-device-count": _ctx.getMeterDeviceCount
        }, null, 8, ["project-data", "include-sections", "consumption-data", "selected-panels", "selected-inverters", "selected-batteries", "selectedEVChargers", "selected-meters", "payment-type", "get-panel-device-count", "get-inverter-device-count", "get-battery-device-count", "getEVChargerDeviceCount", "get-meter-device-count"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowPage3)
      ? (_openBlock(), _createBlock(_component_report_page3, {
          key: 1,
          class: "report-page",
          "project-data": _ctx.projectData,
          "include-sections": _ctx.includeSections,
          "payment-type": _ctx.paymentType
        }, null, 8, ["project-data", "include-sections", "payment-type"]))
      : _createCommentVNode("", true)
  ]))
}